import { module } from 'modujs';
import { gsap } from "gsap";

export default class extends module {
    constructor(m) {
        super(m);

        this.introTop = this.el.querySelector('.c-services_intro_top .c-heading.-h3.-border');
        this.introCenter = this.el.querySelector('.c-services_intro_center');
        this.introBottomTopNum = this.el.querySelector('.c-services_intro_bottom .c-text-num_value');
        this.introBottomTopContent = this.el.querySelector('.c-services_intro_bottom .c-text-num_content');
        this.introBottomContent = this.el.querySelector('.c-services_intro_bottom .c-heading.-h5');
    }

    init() {
        this.el.querySelectorAll('.c-services_item_over').forEach((elt) => {
            let sequenceId = elt.getAttribute('data-sequence');
            elt.addEventListener('mousemove', (e) => {
                const target = e.target;
                const rect = target.getBoundingClientRect();
                const x = e.clientX - rect.left;
                let progress = x / rect.width;
                this.call('setProgress', progress, 'ImagesSequence', sequenceId)
            });
        });

        window.addEventListener('progressService', (e) => {
            const { target, progress } = e.detail;
            let sequenceId = target.getAttribute('data-sequence');
            this.call('setProgress', progress, 'ImagesSequence', sequenceId)
        });
    }

    playIntro(e) {
        if (e.way == 'enter') {
            let tl = gsap.timeline();
            tl.call(() => { this.introTop.classList.add('is-inview'); }, null, 0);
            tl.fromTo(
                this.introCenter.querySelectorAll('.char'),
                { y: '100%', scaleY: 0, },
                { y: 0, scaleY: 1, duration: 0.8, ease: 'elastic.out(1,0.8)', stagger: { from: 'center', each: 0.04 } },
                0.3
            );
            tl.call(() => { this.introBottomTopNum.classList.add('is-inview'); }, null, 0.4);
            tl.call(() => { this.introBottomTopContent.classList.add('is-inview'); }, null, 0.6);
            tl.call(() => { this.introBottomContent.classList.add('is-inview'); }, null, 0.8);

        } else {
            // let tl = gsap.timeline();
            // tl.call(() => { this.introTop.classList.remove('is-inview'); }, null, 0);
            // tl.to(
            //     this.introCenter.querySelectorAll('.char'),
            //     { y: '100%', scaleY: 0, duration: 0.6, ease: 'power4.out' },
            //     0
            // );
            // tl.call(() => { this.introBottomTopNum.classList.remove('is-inview'); }, null, 0);
            // tl.call(() => { this.introBottomTopContent.classList.remove('is-inview'); }, null, 0);
            // tl.call(() => { this.introBottomContent.classList.remove('is-inview'); }, null, 0);
        }
    }
}
